import { DialogTrigger } from "@indietabletop/appkit";
import { EditMode } from "../../engine/EditMode.ts";
import {
  MenuDialogDisclosure,
  MenuSeparator,
  MoreMenu,
} from "../ActionsMenu/ActionsMenu.tsx";
import { EditGitDialog } from "../GitFormDialog/GitFormDialog.tsx";
import { DeleteGitDialog } from "./DeleteGitDialog.tsx";
import { DuplicateGitDialog } from "./DuplicateGitDialog.tsx";
import { ModelContext } from "./ModelContext.tsx";
import { useGit } from "./useGit.tsx";

export function GitActionsMenu() {
  const { git, readOnly } = useGit();

  if (!git || readOnly) {
    return null;
  }

  return (
    <ModelContext value={git}>
      <MoreMenu>
        <DialogTrigger>
          <EditGitDialog />
          <MenuDialogDisclosure>Edit</MenuDialogDisclosure>
        </DialogTrigger>

        {git.can(EditMode.CHANGE, "models") && (
          <>
            <DialogTrigger>
              <DuplicateGitDialog />
              <MenuDialogDisclosure>Duplicate</MenuDialogDisclosure>
            </DialogTrigger>

            <MenuSeparator />

            <DialogTrigger>
              <DeleteGitDialog />
              <MenuDialogDisclosure>Delete</MenuDialogDisclosure>
            </DialogTrigger>
          </>
        )}
      </MoreMenu>
    </ModelContext>
  );
}
